import React from "react";
import Reflux from "reflux";
import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import Select from "react-select";
import LoadingIndicator from "react-loading-indicator";

import logger from "../../../utils/LoggerFrontend";
import Actions from "../../../Actions";
import { QualificationQuestionsStore, StatusStore, PreviewStore } from "../../../Stores";
import { CustomerSucessController, Store__System } from "@talentbait/shared-components";
import ATSSingleQuestion from "./Campaign__Create_ATS__Question.jsx";
import auth from "../../../utils/AuthController";
import { prepareAtsDoc, convertFormalityToBoolean, getLanguageFromLocale } from "./utils";

import { v4 as uuidv4 } from "uuid";

import {
  MainWrapper,
  QualificationsWrapper,
  ChatbotWrapper,
  FormalitySection,
  FormalityItem,
  BreakLine,
  BreakLineDashed,
  AddQuestionPlaceholder,
  SelectMenuStyles,
  QuestionTypesWrapper,
  QuestionType,
  WelcomeMessageSection,
  WelcomeMessageReplySection
} from "./Campaign__Create_ATS.styled.js";

import { HeaderWrapper, Title, Description } from "../Previews/Components/TextSections.jsx";
import { withTranslation } from "react-i18next";

// Orgas that don't use the template message feature
/** @todo No orgas anymore. Remove related code in another PR */
const TEMPLATE_MESSAGE_FEATURE_FLAG = [];

const templateQuestions = ({ t, lng }) => [
  {
    question: t("Wie viel Erfahrung hast Du diesem Bereich?", { lng }),
    key: "Berufserfahrung",
    formality: "Du",
    selections: [
      {
        text: t("< 1 year", { lng }),
        isDisqualifying: true
      },
      {
        text: t("1 - 3 years", { lng }),
        isDisqualifying: false
      }
    ]
  },
  {
    question: t("Welchen Abschluss hast Du?", { lng }),
    key: "Abschluss",
    formality: "Du",
    selections: []
  },
  {
    question: "",
    key: "Kenntnisse",
    formality: "Du",
    selections: []
  },
  {
    question: "",
    key: "Custom",
    formality: "Du",
    selections: []
  },
  {
    question: t("Wie viel Erfahrung haben Sie diesem Bereich?", { lng }),
    key: "Berufserfahrung",
    formality: "Sie",
    selections: [
      {
        text: t("< 1 year", { lng }),
        isDisqualifying: true
      },
      {
        text: t("1 - 3 years", { lng }),
        isDisqualifying: false
      }
    ]
  },
  {
    question: t("Welchen Abschluss haben Sie?", { lng }),
    key: "Abschluss",
    formality: "Sie",
    selections: []
  },
  {
    question: "",
    key: "Kenntnisse",
    formality: "Sie",
    selections: []
  },
  {
    question: "",
    key: "Custom",
    formality: "Sie",
    selections: []
  }
];

const defaultWelcomeMessageSie = ({ t, lng }) => (
  <span>
    {t("Hello", { lng })} <b>{t("Applicant Name", { lng })}</b>,{" "}
    {t("vielen Dank für Ihre Bewerbung bei", { lng })} <b>{t("Company", { lng })}</b>{" "}
    {t("as", { lng })} <b>{t("Title", { lng })}</b>.{" "}
    {t("Wir werden uns zeitnah mit weiteren Schritten bei Ihnen melden.", { lng })}
    <br />
    {t("Best regards", { lng })}, <b>{t("Your Name", { lng })}</b>
  </span>
);

const defaultWelcomeMessageDu = ({ t, lng }) => (
  <span>
    {t("Hello", { lng })} <b>{t("Applicant Name", { lng })}</b>,{" "}
    {t("vielen Dank für Deine Bewerbung bei", { lng })} <b>{t("Company", { lng })}</b>{" "}
    {t("as", { lng })} <b>{t("Title", { lng })}</b>.{" "}
    {t("Wir werden uns zeitnah mit weiteren Schritten bei Dir melden.", { lng })}
    <br />
    {t("Best regards", { lng })}, <b>{t("Your Name", { lng })}</b>
  </span>
);

class CampaignCreateATS extends Reflux.Component {
  constructor(props) {
    super(props);
    this.state = {
      showQuestionTypes: false
    };

    this.stores = [Store__System, StatusStore, QualificationQuestionsStore, PreviewStore];
    this.storeKeys = [
      "hasFetchedHistoricalData",
      "hasFetchedATSOrgaSettings",
      "allChatbotQuestions",
      "selectedChatbotQuestion",
      "questions",
      "applicationEmail",
      "formality",
      "historicalQuestions",
      "hasNewQuestion",
      "userProfile",
      "hasFetchedAtsDataForCampaign",
      "campaignData"
    ];

    this.embed = null;
    this.modal = null;

    this.submitForm = this.submitForm.bind(this);
    this.toggleQuestionTypes = this.toggleQuestionTypes.bind(this);
  }

  getCampaignLanguage() {
    const propsLocale = this.props.campaignLanguage;
    const campaignDataLocale = this.state.campaignData?.locale;

    return getLanguageFromLocale(propsLocale || campaignDataLocale || "de_DE");
  }

  componentDidMount() {
    const { orgaId, campaignId, viewType = "booking" } = this.props;
    const { hasFetchedHistoricalData, hasFetchedATSOrgaSettings } = this.state;

    const languageCode = this.getCampaignLanguage();

    logger.log("CampaignCreateATS:componentDidMount", "called", {
      orgaId,
      campaignId,
      viewType,
      hasFetchedHistoricalData,
      hasFetchedATSOrgaSettings
    });
    const config = {
      kind: "widget",
      url: "https://www.videoask.com/ffl8z5h43",
      options: {
        widgetType: "VideoThumbnailWindowSquare",
        text: "",
        backgroundColor: "#1E22FF",
        position: "bottom-right",
        dismissable: true
      }
    };
    const callbacks = {
      onLoadModal: (modal) => {
        logger.log("CampaignCreateATS:onLoadModal", "called");
        CustomerSucessController.send("QualificationQuestions:openedBigVideo");
        this.modal = modal.element;
      },
      onCloseModal: () => {
        logger.log("CampaignCreateATS:onCloseModal", "called");
        CustomerSucessController.send("QualificationQuestions:closedBigVideo");
      },
      onCloseWidget: () => {
        logger.log("CampaignCreateATS:onCloseWidget", "called");
        CustomerSucessController.send("QualificationQuestions:closedSmallVideo");
      }
    };
    if (viewType == "booking" && window.videoask) {
      window.videoask?.loadEmbed(config, callbacks).then((element) => {
        element.style.marginBottom = "65px";
        element.style.zIndex = "1";
        this.embed = element;
      });
      CustomerSucessController.send("QualificationQuestions:opened");
    }
    if (campaignId) {
      // If we have a campaign created already just get the existing ATS record
      logger.log(
        "CampaignCreateATS:componentDidMount",
        "campaign already created fetching ATS record",
        { campaignId }
      );
      Actions.getAtsData(campaignId);
    }
    if (orgaId && !campaignId && !hasFetchedATSOrgaSettings) {
      // If we don't have an existing campaign, get the ATS Orga settings
      // This is because if we had an exisiting campaign, then there is no
      // need to overwrite the already set states based on the settings
      logger.log("CampaignCreateATS:componentDidMount", "getting ats orga level settings", {
        orgaId,
        locale: languageCode
      });
      Actions.getAtsOrga(orgaId, languageCode);
    }
    if (orgaId && !hasFetchedHistoricalData) {
      // As long as we have an orga, get all previously used questions
      // Only fetches previously used questions.
      logger.log("CampaignCreateATS:componentDidMount", "getting historical questions for orga", {
        orgaId
      });
      Actions.getAllAtsForOrga(orgaId);

      if (!TEMPLATE_MESSAGE_FEATURE_FLAG.includes(orgaId)) {
        logger.log("CampaignCreateATS:componentDidMount", "getting followup question templates", {
          orgaId
        });
        Actions.getFollowupQuestionTemplates(orgaId);
      } else {
        logger.log("CampaignCreateATS:componentDidMount", "getting chatbot question templates", {
          orgaId
        });
        Actions.getAtsTemplatesByType("chatbotQuestion");
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    logger.debug("CampaignCreateATS:componentDidUpdate", "called", {
      prevState,
      state: this.state
    });

    const { questions = [] } = this.state;

    if (questions.length > (prevState.questions || []).length) {
      this.setState({
        showQuestionTypes: false
      });
    }
  }

  componentWillUnmount() {
    CustomerSucessController.send("QualificationQuestions:closed");
    const { viewType = "booking" } = this.props;

    if (viewType != "booking") {
      const languageCode = this.getCampaignLanguage();
      Actions.resetQualificationQuestions(languageCode);
    }
    if (this.modal) {
      this.modal.remove();
      this.modal = null;
    }
    if (this.embed) {
      this.embed.remove();
      this.embed = null;
    }
  }

  toggleQuestionTypes() {
    this.setState({
      showQuestionTypes: !this.state.showQuestionTypes
    });
  }

  checkErrorOnSubmit() {
    const { questions = [] } = this.state;
    const { t } = this.props;
    let hasError = false;

    questions.forEach((question) => {
      if (!question.question) {
        hasError = t("Please enter your question");
      }

      if (question.selections && question.selections.length === 1) {
        hasError = t("Give your applicants at least two answers to decide");
      }

      let disqArr = [];
      const { selections = [] } = question;
      selections.forEach((answer) => {
        disqArr.push(answer.isDisqualifying);
      });
      if (!disqArr.includes(false) && disqArr.includes(true)) {
        hasError = t(
          "Oh oh! All possible answers disqualify your applicants. No one can get through to you right now."
        );
      }
    });

    return hasError;
  }
  submitForm(updates = {}) {
    const { questions, selectedChatbotQuestion, formality, hasFetchedAtsDataForCampaign } = {
      ...this.state,
      ...updates
    };
    const { orgaId, campaignId } = this.props;

    logger.log("CampaignCreateATS:submitForm", "updating ATS record for campaign", {
      selectedChatbotQuestion,
      formality,
      questions,
      orgaId,
      campaignId
    });
    if (!campaignId) {
      logger.log("CampaignCreateATS:submitForm", "No campaignId set, stop here", {
        selectedChatbotQuestion,
        formality,
        questions
      });
      return;
    }

    // Prepare ats document
    const atsData = prepareAtsDoc({ formality, questions, selectedChatbotQuestion, orgaId });

    let hasError = this.checkErrorOnSubmit();

    if (hasError) {
      logger.log("CampaignCreateATS:submitForm", "has error", { error: hasError, campaignId });
      // CustomerSucessController.send("QualificationQuestions:errorGoingToNext", { error: hasError });
      // Actions.addNotification(hasError, "error");
      return;
    }

    if (!hasFetchedAtsDataForCampaign) {
      logger.log("CampaignCreateATS:submitForm", "hasFetchedAtsDataForCampaign", { campaignId });
      return;
    }
    Actions.updateAtsWithCampaignId(campaignId, atsData);
    const user = auth.getCurrentUser();
    const userName = user.displayName;
    Actions.logCampaignActivity(campaignId, {
      message: `Edited Qualification Questions`,
      type: "View",
      orgaId: orgaId,
      date: new Date().toISOString(),
      userName
    });

    let text = `🔄👤 Die Qualifizierungsfragen wurde von *${userName}* geändert \n`;
    text += `${window.baseUrlInteralTools}/admin-campaign/${orgaId}/${campaignId}\n`;

    Actions.notifiyEvent({
      text,
      orgaId,
      campaignId,
      userName
    });
    CustomerSucessController.send("QualificationQuestions:finished", { atsData, campaignId });
    return;
  }

  convertQuestionTypeLabels(key) {
    const { t } = this.props;

    if (key == "Custom") {
      return t("+ Other questions");
    }
    // keys are Berufserfahrung, Abschluss, Kenntnisse, Custom
    // eslint-disable-next-line react-i18n/no-dynamic-translation-keys
    return `+ ${t(key)}`;
  }

  renderQuestionTypes() {
    const { t } = this.props;
    const { showQuestionTypes, formality } = this.state;
    if (!showQuestionTypes) {
      return <div />;
    }

    const languageCode = this.getCampaignLanguage();

    const filteredTemplateQuestions = templateQuestions({
      t,
      lng: languageCode
    }).filter((question) => question.formality === formality);

    return (
      <QuestionTypesWrapper>
        {filteredTemplateQuestions.map((question, index) => {
          const { key } = question;

          return (
            <QuestionType
              key={index}
              onClick={() => {
                this.addQualificationQuestion(question);
              }}
            >
              {this.convertQuestionTypeLabels(key)}
            </QuestionType>
          );
        })}
      </QuestionTypesWrapper>
    );
  }

  updateQualificationQuestion(questionIndex, questionObject) {
    const { questions } = this.state;

    const newQuestionList = structuredClone(questions);

    newQuestionList[questionIndex] = questionObject;
    Actions.updateQualificationQuestion(newQuestionList);

    logger.log("CampaignCreateATS:updateQualificationQuestion", "called", {
      questionIndex,
      newQuestionList,
      questionObject
    });

    this.submitForm({ questions: newQuestionList });
  }

  deleteQualificationQuestion(questionIndex) {
    const { questions } = this.state;

    const newQuestionList = structuredClone(questions);

    logger.debug("CampaignCreateATS:deleteQualificationQuestion", "called", {
      questionIndex,
      newQuestionList
    });
    newQuestionList.splice(questionIndex, 1);
    Actions.updateQualificationQuestion(newQuestionList);
    this.submitForm({ questions: newQuestionList });
  }

  addQualificationQuestion(newQuestionObject) {
    let { questions = [] } = this.state;

    let newQuestionList = structuredClone(questions);

    logger.debug("CampaignCreateATS:addQualificationQuestion", "called", {
      ...newQuestionList
    });
    newQuestionObject.id = uuidv4();

    newQuestionList = newQuestionList.concat([newQuestionObject]);
    Actions.updateQualificationQuestion(newQuestionList, true);
    this.submitForm({ questions: newQuestionList });
  }

  strippedPunctuationAndTranslated = (item, index, language) => {
    const { t } = this.props;

    const match = item.match(/{{(.+?)}}([.,!?:;]*)/);
    if (match) {
      const word = match[1]; // Extract word inside {{ }}
      const punctuation = match[2] || ""; // Extract punctuation (if any)

      return (
        <span key={index}>
          {/* eslint-disable-next-line react-i18n/no-dynamic-translation-keys */}
          <b>{t(word, { lng: language })}</b>
          {punctuation}{" "}
        </span>
      );
    }
  };

  cleanTemplate({ templateMessage = "", applicationEmail = "", language }) {
    const replacements = {
      "{{name}}": "{{Bewerbername}}",
      "{{title}}": "{{Titel}}",
      "{{recruiterName}}": "{{Ihr Name}}",
      "{{companyName}}": "{{Firma}}",
      "{{applicationEmail}}": `{{${applicationEmail}}}`
    };

    const list = templateMessage
      .replaceAll("\\n", "\n")
      .split(/[\s\n]+/)
      .map((item, index) => {
        Object.entries(replacements).forEach(([key, value]) => {
          item = item.replace(key, value);
        });

        return item.includes("{{")
          ? this.strippedPunctuationAndTranslated(item, index, language)
          : item + " ";
      });

    return list;
  }

  renderFollowupQuestions() {
    const { allChatbotQuestions, selectedChatbotQuestion, formality, applicationEmail } =
      this.state;

    const { t } = this.props;

    const campaignLanguage = this.getCampaignLanguage();

    // Filter based on formality of the chatbot question (Sie/Du) and campaign locale
    const isFormal = convertFormalityToBoolean(formality);

    const language = getLanguageFromLocale(campaignLanguage);

    // Create fallback options if we don't have any for the current locale
    const fallbackOptions = allChatbotQuestions?.filter(
      (question) => question.isFormal === isFormal
    );

    let options = allChatbotQuestions?.filter((question) => question.language === language);

    if (language === "de") {
      options = options?.filter((question) => question.isFormal === isFormal);
    }

    logger.log("CampaignCreateATS:renderFollowupQuestions", "options", {
      options,
      language,
      campaignLanguage,
      isFormal,
      fallbackOptions,
      allChatbotQuestions
    });

    // If we don't have any options for the current locale, use the fallback options
    if (options.length === 0) {
      options = fallbackOptions;
    }

    if (!applicationEmail) {
      options = options?.filter((q) => !q.text?.includes("{{applicationEmail}}"));
    }

    options = options.map((q) => ({
      label: this.cleanTemplate({ templateMessage: q.text, applicationEmail, language }),
      value: q
    }));
    let currentlySelected = options.find((opt) => opt.value.id === selectedChatbotQuestion);

    if (options.length <= 2) {
      logger.log(
        "error:CampaignCreateATS:renderFollowupQuestions",
        "only showing limited followup questions",
        { options: options.map((option) => option.value) }
      );
    }

    logger.log("CampaignCreateATS:renderFollowupQuestions", "about to render question options", {
      options,
      language,
      campaignLanguage,
      isFormal,
      fallbackOptions,
      allChatbotQuestions
    });

    return (
      <Select
        menuPlacement="top"
        styles={SelectMenuStyles}
        options={options}
        onChange={(option) => {
          logger.log("CampaignCreateATS:onChange", "changed question", { selected: option.value });
          CustomerSucessController.send("QualificationQuestions:changedChatbotQuestion", {
            question: option.value
          });
          Actions.updateChatbotQuestion(option?.value?.id || "");
          logger.debug("CampaignCreateATS:updateChatbotQuestion", "finished", {
            new: option?.value?.text,
            newId: option?.value?.id,
            old: selectedChatbotQuestion
          });
          // Pass in the new update before we save to DB
          this.submitForm({ selectedChatbotQuestion: option?.value?.id });
        }}
        placeholder={t("First chatbot message")}
        value={currentlySelected}
        noOptionsMessage={() => null}
        isSearchable={false}
      />
    );
  }

  updateChatbotQuestion = (option) => {
    const newChatbotQuestion = option?.value?.text || "";

    logger.log("CampaignCreateATS:onChange", "changed question", { selected: option.value });

    CustomerSucessController.send("QualificationQuestions:changedChatbotQuestion", {
      question: option.value
    });

    Actions.updateChatbotQuestion(newChatbotQuestion);

    logger.debug("CampaignCreateATS:updateChatbotQuestion", "finished", {
      new: newChatbotQuestion,
      old: this.state.selectedChatbotQuestion
    });

    // Pass in the new update before we save to DB
    this.submitForm({ selectedChatbotQuestion: newChatbotQuestion });
  };

  renderChatbotQuestions() {
    const { allChatbotQuestions, selectedChatbotQuestion, formality, applicationEmail } =
      this.state;

    const { t } = this.props;

    const campaignLanguage = this.getCampaignLanguage();

    // Old templates have the language in uppercase, new ones have it in lowercase
    const language = getLanguageFromLocale(campaignLanguage).toUpperCase();

    // Filter based on formality of the chatbot question (Sie/Du) and campaign locale
    const isFormal = convertFormalityToBoolean(formality);

    // Create fallback options if we don't have any for the current locale
    const fallbackOptions = allChatbotQuestions?.filter(
      (question) => question.isFormal === isFormal
    );

    let options = allChatbotQuestions
      ?.filter((question) => question.isFormal === isFormal)
      .filter((question) => question.language === language);

    logger.log("CampaignCreateATS:renderChatbotQuestions", "options", {
      options,
      fallbackOptions
    });

    // If we don't have any options for the current locale, use the fallback options
    if (options.length === 0) {
      options = fallbackOptions;
    }

    if (!applicationEmail) {
      options = options?.filter((q) => !q.text?.includes("{{applicationEmail}}"));
    }

    options = options.map((q) => ({
      label: this.cleanTemplate({ templateMessage: q.text, applicationEmail, language }),
      value: q
    }));
    let currentlySelected = options.find((opt) => opt.value.text === selectedChatbotQuestion);

    if (options.length <= 2) {
      logger.log(
        "error:CampaignCreateATS:renderChatbotQuestions",
        "only showing limited chatbot questions",
        { options: options.map((option) => option.value) }
      );
    }

    return (
      <Select
        menuPlacement="top"
        styles={SelectMenuStyles}
        options={options}
        onChange={this.updateChatbotQuestion}
        placeholder={t("First chatbot message")}
        value={currentlySelected}
        noOptionsMessage={() => null}
        isSearchable={false}
      />
    );
  }

  updateFormality = () => {
    const formality = this.state.formality === "Sie" ? "Du" : "Sie";
    const languageCode = this.getCampaignLanguage();

    Actions.updateATSFormality(formality, this.props.orgaId, languageCode);
    this.submitForm({ formality });
  };

  render() {
    const {
      showQuestionTypes,
      formality,
      historicalQuestions,
      hasNewQuestion,
      hasFetchedAtsDataForCampaign,
      questions = []
    } = this.state;

    const { viewType = "booking", t } = this.props;

    const questionsAmount = questions.length;

    const checked = formality == "Du";
    const backgroundColor = checked ? "#5F5C70" : "#ccc";
    const borderColor = checked ? "#5F5C70" : "#ccc";

    if (viewType == "selfserviceEditing" && hasFetchedAtsDataForCampaign == false) {
      return (
        <div>
          {t("Loading")} <br />
          <LoadingIndicator />
        </div>
      );
    }

    const languageCode = this.getCampaignLanguage();

    return (
      <div>
        <MainWrapper>
          {viewType != "selfserviceEditing" && <BreakLineDashed />}

          <HeaderWrapper fullWidth={viewType == "selfserviceEditing"}>
            <Title withMargin={viewType != "selfserviceEditing"}>
              {t("Qualification questions")}
            </Title>
            <FormalitySection>
              <FormalityItem>{t("Formal")}</FormalityItem>
              <FormalityItem data-tip={t("How would you like to address your applicants?")}>
                <Switch
                  checked={checked}
                  onChange={this.updateFormality}
                  style={{ backgroundColor, borderColor }}
                />
              </FormalityItem>
              <FormalityItem>{t("Informal")}</FormalityItem>
            </FormalitySection>
            <Description>{t("Qualification questions description")}</Description>
          </HeaderWrapper>
          <QualificationsWrapper fullWidth={viewType == "selfserviceEditing"}>
            {questions.map((question, index) => (
              <div key={index + "_" + question.key}>
                {index != 0 && <BreakLine />}
                <ATSSingleQuestion
                  question={question}
                  questionIndex={index}
                  isNewQuestion={hasNewQuestion && index == questionsAmount - 1}
                  formality={formality}
                  historicalQuestions={historicalQuestions}
                  updateQualificationQuestion={this.updateQualificationQuestion.bind(this)}
                  deleteQualificationQuestion={this.deleteQualificationQuestion.bind(this)}
                />
              </div>
            ))}
            <BreakLineDashed />
            <AddQuestionPlaceholder
              isActive={showQuestionTypes}
              onClick={this.toggleQuestionTypes.bind(this)}
            >
              <span data-tip={t("What would you like to know from your candidates?")}>
                + {t("Add Question")}
              </span>
            </AddQuestionPlaceholder>

            {this.renderQuestionTypes()}
          </QualificationsWrapper>

          <HeaderWrapper fullWidth={viewType == "selfserviceEditing"}>
            <Title>{t("Applicant Communication")}</Title>
            <Description>{t("Applicant Communication description")}</Description>
          </HeaderWrapper>

          <ChatbotWrapper fullWidth={viewType == "selfserviceEditing"}>
            <WelcomeMessageSection>
              {formality == "Sie" && defaultWelcomeMessageSie({ t, lng: languageCode })}
              {formality == "Du" && defaultWelcomeMessageDu({ t, lng: languageCode })}
            </WelcomeMessageSection>
            <WelcomeMessageReplySection>
              {t("Thank you for the confirmation! I look forward to the next steps", {
                lng: languageCode
              })}
            </WelcomeMessageReplySection>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            {!TEMPLATE_MESSAGE_FEATURE_FLAG.includes(this.props.orgaId)
              ? this.renderFollowupQuestions()
              : this.renderChatbotQuestions()}
          </ChatbotWrapper>

          {this?.props?.children}
        </MainWrapper>
      </div>
    );
  }
}

export default withTranslation()(CampaignCreateATS);
